export default function UserAvatarLetters(name: string | null | undefined) {
  const nameParts = (name?.split(' ') ?? []).filter((x) => !!x);
  return nameParts
    .slice(0, 2)
    .map((x) => x[0])
    .join('')
    .toLocaleUpperCase();
}
